import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'components/alf-design';
import { timesCircle } from 'assets/icon';

const styles = {
  oh: {
    fontSize: 'min(36rem, calc(36px * 1.5))',
    lineHeight: '36px',
    textAlign: 'center',
    opacity: '10%',
  },
  title: {
    marginBottom: 8,
  },
};

const FallbackContent = () => {
  return (
    <div className="block sm:flex items-center justify-center">
      <div className="min-w-[300px] sm:w-1/2 flex flex-col items-center">
        <img
          alt=""
          src={timesCircle}
          className="w-[128px] h-[128px] mb-[24px] mt-[24px] sm:mt-[0px]"
        />
        <Typography type="black" component="h2" style={styles.oh}>
          uh - oh!
        </Typography>
      </div>
      <div className="min-w-[300px] sm:w-1/2 grid gap-[16px] text-center sm:text-left m-[24px] sm:m-[0px]">
        <Typography type="h1" component="h1" style={styles.title}>
          Something went wrong.
        </Typography>
        <Typography type="caption1">
          If you need immediate assistance, please contact Customer Service at{' '}
          <a href="tel:8007482030" className="text-legacy-primary no-underline">
            (800) 748-2030
          </a>
          .
        </Typography>
        <Typography type="caption1">
          Otherwise, please go back and try again.
        </Typography>
      </div>
    </div>
  );
};

FallbackContent.propTypes = {
  onRecover: PropTypes.func,
};

export default FallbackContent;
